import { useEditEventTypeMutation } from '@/queries/eventTypes.queries';
import { useListResourcesQuery } from '@/queries/resources.queries';
import IEventType from '@/types/IEventType';
import IResource from '@/types/IResource';
import { useToast } from '@chakra-ui/react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

interface IArgs {
	eventType: IEventType;
	isOpen: boolean;
	close: () => void;
}

interface IValues {
	resource: IResource | null;
	email?: { label: string; value: string } | null;
}

export function useAddMemberModal(args: IArgs) {
	const updateEventTypeMutation = useEditEventTypeMutation();
	const availabilitiesQuery = useListResourcesQuery();
	const toast = useToast();
	const { t } = useTranslation();

	const form = useForm<IValues>({ defaultValues: { resource: null, email: { label: '', value: '' } } });

	const handleSubmit = form.handleSubmit((values) => {
		if (!values.resource) {
			return;
		}

		return updateEventTypeMutation
			.mutateAsync({
				...args.eventType,
				resourceRules: {
					...(args.eventType.resourceRules || {}),
					linkedResources: [...(args.eventType.resourceRules?.linkedResources || []), { id: values.resource.id }],
				},
			})
			.then(() => {
				toast({
					isClosable: true,
					status: 'success',
					title: t('Success'),
				});
				form.reset();
				args.close();
			});
	});

	return {
		availabilitiesQuery,
		form,
		handleSubmit,
		t,
	};
}
